import React, { Component } from 'react';

/**
 * A component to wrap other components with to support code splitting and async loading.
 * https://serverless-stack.com/chapters/code-splitting-in-create-react-app.html
 *
 * @param importComponent function that calls import() to get the wrapped component
 * @returns {AsyncComponent}
 */
export default function asyncComponent( importComponent )
{
  class AsyncComponent extends Component
  {
    constructor( props )
    {
      super( props );
      this.state = { component: null };
    }

    async componentDidMount()
    {
      const { 'default' : component } = await importComponent();
      this.setState( { component: component } );
    }

    render()
    {
      const C = this.state.component;
      // we could render a spinner or loading img here when null
      return C ? <C {...this.props} /> : null;
    }
  }

  return AsyncComponent;
}


// WEBPACK FOOTER //
// ../../src/AsyncComponent/AsyncComponent.js